import { render } from "./KycVerificationRequired.vue?vue&type=template&id=c83116bc&scoped=true"
import script from "./KycVerificationRequired.vue?vue&type=script&lang=js"
export * from "./KycVerificationRequired.vue?vue&type=script&lang=js"

import "./KycVerificationRequired.vue?vue&type=style&index=0&id=c83116bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83116bc"]])

export default __exports__